import { render, staticRenderFns } from "./MeetingManagerPage.vue?vue&type=template&id=2ff8f2c4&scoped=true"
import script from "./MeetingManagerPage.vue?vue&type=script&lang=ts"
export * from "./MeetingManagerPage.vue?vue&type=script&lang=ts"
import style0 from "./MeetingManagerPage.vue?vue&type=style&index=0&id=2ff8f2c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff8f2c4",
  null
  
)

export default component.exports